import http from '@/utils/http';

import type { AxiosRequestConfig } from 'axios';

/**
 * Fetch available quarter dates for reports
 * @param params Request parameters
 * @param params.open_id Optional user open_id
 * @param config Axios configuration
 * @returns Response with all_dates (system-wide) and user_dates (user-specific)
 */
export const fetchQuarterReportDates = (
  params: {
    open_id?: string;
  },
  config?: AxiosRequestConfig,
): IBaseResponse<IQuarterDatesResponse> => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/quarter_report/dates',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};

// TODO: 联调季度月报详情数据接口
/**
 * 拉取季度月报详情数据
 * @param params 参数对象
 * @param params.date 季度月报的季度日期
 * @param params.open_id 季度月报的作者
 * @param config axios配置
 * @reutrn 季度月报详情数据
 */
export const fetchQuarterReportDetails = (
  params: {
    date: string;
    open_id?: string;
  },
  config?: AxiosRequestConfig,
): IBaseResponse<IQuarterReportDetails> => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/quarter_report/details',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};
